import { Pipe, PipeTransform } from "@angular/core";
import { sanitizeDirectusObject } from "../../../../../../../common/utils/sanitize-directus-object";
import { ItemsSuppliers } from "../../../../../../api/packbo/models/items-suppliers";

type GeoPoint = {
    coordinates: [number, number];
    type: "Point";
};

@Pipe({
    name: "calculateDistance"
})
export class CalculateDistancePipe implements PipeTransform {
    public transform(supplier: ItemsSuppliers, userLocation: google.maps.LatLngLiteral | null): number | null {
        if (!userLocation || !supplier.coord_ref) {
            return null;
        }

        const coordRef = sanitizeDirectusObject(supplier.coord_ref);
        if (!coordRef?.geo_point) {
            return null;
        }

        const geoPoint = coordRef.geo_point as GeoPoint;
        if (!geoPoint?.coordinates || geoPoint.coordinates.length !== 2) {
            return null;
        }

        const [lng, lat] = geoPoint.coordinates;
        const supplierLocation: google.maps.LatLngLiteral = { lat, lng };
        const distanceInMeters = google.maps.geometry.spherical.computeDistanceBetween(userLocation, supplierLocation);
        const distanceInKm = distanceInMeters / 1000;

        return distanceInKm < 1 ? Math.round(distanceInKm * 10) / 10 : Math.round(distanceInKm);
    }
}
